import { render, staticRenderFns } from "./Politicas.vue?vue&type=template&id=b46585bc"
import script from "./Politicas.vue?vue&type=script&lang=js"
export * from "./Politicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports